import store from 'store'

/**
 * Limpia toda la sesion local y redirige al login correspondiente.
 * @param {string} [origenManual] Ruta a la que se desea redirigir (ej. '/loginSuperAdmin' o '/login')
 */
export const limpiarSesionYRedirigir = (origenManual) => {
    let target = '/login';
    try {
        if (origenManual && typeof origenManual === 'string') {
            target = origenManual;
        } else {
            const data = store.get('data');
            if (data && data.origin) {
                target = data.origin;
            } else if (window.location && window.location.hash && window.location.hash.toLowerCase().includes('dashboardsa')) {
                target = '/loginSuperAdmin';
            }
        }
    } catch (e) {
        console.error('Error al resolver ruta de destino de login:', e);
    }

    if (!target.startsWith('/')) {
        target = '/' + target;
    }

    // Limpiar exhaustivamente el estado local
    try { store.remove('loggedIn'); } catch (e) {}
    try { store.remove('data'); } catch (e) {}
    try { store.clearAll(); } catch (e) {}
    try { localStorage.clear(); } catch (e) {}
    try { sessionStorage.clear(); } catch (e) {}

    // Redirigir usando el hash de React Router (HashRouter)
    if (window.location && window.location.hash !== `#${target}`) {
        window.location.hash = target;
    }
};

// Interceptor global sobre window.fetch
if (typeof window !== 'undefined' && window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
        try {
            const response = await originalFetch.apply(this, args);
            // Si el backend responde 401 (Unauthorized) o 403 (Forbidden), la sesion no es valida
            if (response && (response.status === 401 || response.status === 403)) {
                console.warn(`[FetchInterceptor] Acceso no autorizado o sesion invalida (${response.status}). Redirigiendo a login...`);
                limpiarSesionYRedirigir();
            }
            return response;
        } catch (error) {
            throw error;
        }
    };
}

const safeFetch = (...args) => window.fetch(...args);
safeFetch.limpiarSesionYRedirigir = limpiarSesionYRedirigir;

export default safeFetch;